import { useEffect } from "react";
import { useActivityEventsStore } from "@/store/activityEventsStore";
import { useItemVersionMs } from "./itemsStore";

/**
 * Loads an item's change log into the activity events store, and reloads it
 * whenever the cached item moves, so a save lands in the log. Called once by
 * the editor; the History tab and the unit cost subline read the store.
 * @param itemId - The item to load, or null to load nothing
 */
export function useFetchItemEvents(itemId: string | null): void {
  const fetchActivityEvents = useActivityEventsStore(
    (state) => state.fetchActivityEvents,
  );
  const itemVersionMs = useItemVersionMs(itemId);

  useEffect(() => {
    if (!itemId) {
      return;
    }
    fetchActivityEvents("ITEM", itemId).catch(() => undefined);
  }, [itemId, itemVersionMs, fetchActivityEvents]);
}
